/* ==========================================================================
   MU product page behaviour
   - Quantity offers: selecting a tier sets the quantity that is added to the cart
     and re-prices every tier from the selected variant (works with variant changes).
   - Expert review "read more" and customer review "show more" toggles.
   Variant selection, gallery, Add to cart and the sticky bar are handled by theme.js.
   No dependencies.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- helpers (pure, unit-testable) ---------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';
    switch (kind) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /**
   * Price a tier for a variant.
   * units = quantity added to the cart, free = how many of those units are free,
   * pct = extra percentage taken off the paid units.
   */
  function priceTier(variant, units, free, pct) {
    var price = variant.price || 0;
    var compareUnit = variant.compare > price ? variant.compare : price;
    units = Math.max(1, parseInt(units, 10) || 1);
    free = Math.min(units - 1, Math.max(0, parseInt(free, 10) || 0));
    pct = Math.min(100, Math.max(0, parseFloat(pct) || 0));
    var total = Math.round(price * (units - free) * (100 - pct) / 100);
    var compareTotal = compareUnit * units;
    var each = Math.round(total / units);
    var off = compareTotal > total ? Math.round(100 - (total * 100) / compareTotal) : 0;
    return { total: total, compareTotal: compareTotal, each: each, off: off };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { formatMoney: formatMoney, priceTier: priceTier };
    return;
  }

  if (window.__muPdpLoaded) return;
  window.__muPdpLoaded = true;

  var doc = document;
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function moneyFormat() { return (window.volt && window.volt.moneyFormat) || '${{amount}}'; }

  /* ---------- quantity offers ---------- */
  function initOffers(section) {
    var offers = $('[data-mu-offers]', section);
    if (!offers || offers.getAttribute('data-mu-ready')) return;
    offers.setAttribute('data-mu-ready', 'true');

    var json = $('[data-product-json]', section);
    var product = null;
    try { product = json ? JSON.parse(json.textContent) : null; } catch (e) { product = null; }
    var variantInput = $('[data-variant-id]', section);
    var qtyInput = $('[data-mu-qty]', section) || $('[data-product-form] input[name="quantity"]', section);
    var eachTemplate = offers.getAttribute('data-each-template') || '[amount] each';

    function currentVariant() {
      if (!product) return null;
      var id = variantInput ? parseInt(variantInput.value, 10) : NaN;
      for (var i = 0; i < product.variants.length; i++) if (product.variants[i].id === id) return product.variants[i];
      return product.variants[0] || null;
    }

    function render(variant) {
      variant = variant || currentVariant();
      if (!variant) return;
      var fmt = moneyFormat();
      $$('[data-mu-tier]', offers).forEach(function (tier) {
        var input = $('[data-mu-input]', tier);
        var r = priceTier(variant, input.getAttribute('data-units'), input.getAttribute('data-free'), input.getAttribute('data-pct'));
        var total = $('[data-mu-total]', tier);
        var was = $('[data-mu-was]', tier);
        var off = $('[data-mu-off]', tier);
        var each = $('[data-mu-each]', tier);
        if (total) total.textContent = formatMoney(r.total, fmt);
        if (was) { was.textContent = formatMoney(r.compareTotal, fmt); was.hidden = !(r.compareTotal > r.total); }
        if (off) { off.textContent = r.off + '% off'; off.hidden = !(r.off > 0); }
        if (each) each.textContent = eachTemplate.replace('[amount]', formatMoney(r.each, fmt));
      });
    }

    function selectByUnits(units) {
      var matched = false;
      $$('[data-mu-input]', offers).forEach(function (inp) {
        var is = inp.getAttribute('data-units') === String(units);
        inp.checked = is;
        if (is) matched = true;
      });
      return matched;
    }

    offers.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('[data-mu-input]')) return;
      if (qtyInput) {
        qtyInput.value = inp.getAttribute('data-units');
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    // A visible quantity selector keeps the highlighted tier in sync
    if (qtyInput && qtyInput.type !== 'hidden') {
      qtyInput.addEventListener('change', function () { selectByUnits(parseInt(qtyInput.value, 10) || 1); });
    }

    // Variant changes (handled by theme.js) re-price the tiers
    section.addEventListener('volt:variant:change', function (e) {
      render(e.detail && e.detail.variant);
    });

    // Initial state: checked tier decides the quantity
    var checked = $('[data-mu-input]:checked', offers);
    if (checked && qtyInput) qtyInput.value = checked.getAttribute('data-units');
    render();
  }

  /* ---------- toggles ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-mu-toggle]') : null;
    if (t) {
      var target = doc.getElementById(t.getAttribute('aria-controls'));
      if (!target) return;
      var open = target.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      t.textContent = open ? t.getAttribute('data-less') : t.getAttribute('data-more');
      return;
    }
    var more = e.target.closest ? e.target.closest('[data-mu-more]') : null;
    if (more) {
      var list = doc.getElementById(more.getAttribute('aria-controls'));
      if (!list) return;
      var step = parseInt(more.getAttribute('data-step'), 10) || 5;
      var hidden = $$('[hidden]', list).filter(function (el) { return el.hasAttribute('data-mu-item'); });
      hidden.slice(0, step).forEach(function (el) { el.hidden = false; });
      if (hidden.length <= step) more.hidden = true;
    }
  });

  function initAll(ctx) {
    $$('[data-product-section]', ctx || doc).forEach(initOffers);
    if (ctx && ctx.matches && ctx.matches('[data-product-section]')) initOffers(ctx);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
